import React, { useState, useEffect } from "react";
import { Eye, Check, CheckCircle2 } from "lucide-react";
import * as roldanApi from "../../../../../../ApiCalls/taktikApiCalls/roldanApi";
import "./AlertasList.scss";

const AlertasList = ({ mantisBusinessId, mantisBusinessUserId, token, onRemesaSelect, refreshTrigger }) => {
  const [alertas, setAlertas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAlertas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mantisBusinessId, refreshTrigger]);

  const loadAlertas = async () => {
    setLoading(true);
    try {
      const res = await roldanApi.getAlertas(mantisBusinessId, token, { estado: "Abierta", limit: 100 });
      if (res?.success) setAlertas(res.data || []);
    } catch (error) {
      console.error("Error loading alertas:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleResolver = async (alertaId) => {
    const comentario = prompt("Ingrese comentario de resolución:");
    if (!comentario) return;

    try {
      const res = await roldanApi.resolverAlerta(mantisBusinessId, mantisBusinessUserId, token, alertaId, comentario);
      if (res?.success) {
        loadAlertas();
      }
    } catch (error) {
      console.error("Error resolviendo alerta:", error);
    }
  };

  const handleMarkAsSeen = async (alertaId, e) => {
    if (e) e.stopPropagation();
    try {
      const res = await roldanApi.markAlertaVista(mantisBusinessId, mantisBusinessUserId, token, alertaId);
      if (res?.success) {
        // Update the alert in the local state
        setAlertas(prevAlertas =>
          prevAlertas.map(alerta =>
            alerta.alerta_id === alertaId
              ? { ...alerta, vista: true, fecha_vista: new Date().toISOString(), vista_por_userid: mantisBusinessUserId }
              : alerta
          )
        );
      }
    } catch (error) {
      console.error("Error marking alerta as seen:", error);
    }
  };

  if (loading) return <div>Cargando...</div>;

  return (
    <div className="alertas-list">
      <h1>Alertas de Validación</h1>
      <div className="alertas-grid">
        {alertas.map((alerta) => (
          <div 
            key={alerta.alerta_id} 
            className={`alerta-card cursor-pointer hover:shadow-md transition-shadow ${alerta.vista ? 'alerta-vista' : ''}`}
            onClick={() => onRemesaSelect && onRemesaSelect(alerta.remesa_id)}
          >
            <div className="alerta-header">
              <div className="alerta-header-left">
                <span className="alerta-tipo">{alerta.tipo_alerta}</span>
                {alerta.vista && (
                  <span className="vista-badge" title={`Vista el ${new Date(alerta.fecha_vista).toLocaleDateString()}`}>
                    <CheckCircle2 size={14} /> Vista
                  </span>
                )}
              </div>
              <span className="alerta-estado">{alerta.estado}</span>
            </div>
            <div className="alerta-body">
              <p><strong>Remesa:</strong> {alerta.numero_remesa || `Remesa ID: ${alerta.remesa_id}`}</p>
              <p><strong>Mensaje:</strong> {alerta.mensaje_error}</p>
              <p><strong>Fecha:</strong> {new Date(alerta.fecha_creacion).toLocaleDateString()}</p>
              {alerta.vista && alerta.fecha_vista && (
                <p><strong>Vista:</strong> {new Date(alerta.fecha_vista).toLocaleDateString()}</p>
              )}
            </div>
            <div className="alerta-actions" onClick={(e) => e.stopPropagation()}>
              {!alerta.vista && (
                <button 
                  onClick={(e) => handleMarkAsSeen(alerta.alerta_id, e)} 
                  className="btn-mark-seen"
                  title="Marcar como vista"
                >
                  <CheckCircle2 size={18} /> Marcar como vista
                </button>
              )}
              <button onClick={() => onRemesaSelect && onRemesaSelect(alerta.remesa_id)} className="btn-icon">
                <Eye size={18} /> Ver Remesa
              </button>
              <button onClick={() => handleResolver(alerta.alerta_id)} className="btn-resolve">
                <Check size={18} /> Resolver
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlertasList;

